<template>
    <div>
        <b-form-row class="mb-2">
            <b-col sm="6" md="3" lg="2">
                <label class="label-text">Type</label>
                <b-form-select v-model="measureTypeValue" :options="measureTypeOptions"></b-form-select>
            </b-col>
            <b-col sm="6" md="3" lg="2">
                <label class="label-text">Aggregation</label>
                <b-form-select v-model="aggregationTypeValue" :options="aggregationTypeOptions"></b-form-select>
            </b-col>
            <b-col sm="6" md="3" lg="2">
                <label class="label-text">Max frequencies</label>
                <b-form-select v-model="maxFreqValue" :options="maxFreqOptions"></b-form-select>
            </b-col>
            <b-col sm="6" md="3" lg="2">
                <label class="label-text">Target group</label>
                <b-form-select v-model="targetGroup" :options="targetGroupRofOptions"></b-form-select>
            </b-col>
            <b-col sm="6" md="3" lg="2" class="d-flex">
                <b-button variant="primary" class="mt-auto" @click="updateRoF" size="sm"> <b-icon icon="arrow-repeat"></b-icon> Update </b-button>
            </b-col>
        </b-form-row>
        <b-form-row class="mb-2 mt-4 d-flex justify-content-center">
            <Spinner v-if="RoFStatus == 'LOADING'" />
            <div class="failedRequest" v-else-if="RoFStatus == 'FAILED'">
                Cannot return result due to a server error.
            </div>
            <div v-else-if="RoFStatus == 'LOADED'">
                <b-table
                    class="text-left mt-4 tablemainresultclass"
                    thead-class="stickyfancytableheader thtablesrofsameheight"
                    striped
                    bordered
                    dense
                    sort-icon-left
                    :small="true"
                    :no-local-sorting="true"
                    :fields="initialTableColumns"
                    :items="initialTableItem"
                    :head-variant="'dark'"
                >
                    <template v-slot:cell(channelNames)="row">
                        <div class="position-relative">
                            <div class="tdchanneltextwrapperclass">
                                <span>{{ row.item.channelNames }}</span>
                            </div>
                            <b-icon
                                v-if="JSON.stringify(firstChannelNames) !== JSON.stringify(channelNames)"
                                @click="expandOrCollapseChannels"
                                :icon="channelsExpanded ? 'dash-square' : 'plus-square'"
                                class="tdicon"
                                variant="primary"
                            ></b-icon>
                        </div>
                    </template>
                    <template v-slot:cell(filmcodes)="row">
                        <div class="position-relative">
                            <div class="tdchanneltextwrapperclass">
                                <span>{{ row.item.filmcodes }}</span>
                            </div>
                            <b-icon
                                @click="expandOrCollapseFilmcodes"
                                v-if="JSON.stringify(firstFilmcodes) !== JSON.stringify(filmcodes)"
                                :icon="filmcodesExpanded ? 'dash-square' : 'plus-square'"
                                class="tdicon"
                                variant="primary"
                            ></b-icon>
                        </div>
                    </template>
                </b-table>
                <b-button @click="showDetails" v-if="isShowDetailsBtnVisible" size="sm" variant="primary" class="mt-2">Show details</b-button>
                <label class="label-text float-left mt-2" v-if="showTableDetails">Number of records: {{ allRofRows.length }}</label>
                <b-table
                    v-if="showTableDetails"
                    class="text-left mt-4 tablemainresultclass"
                    thead-class="stickyfancytableheader thtablesrofsameheight"
                    striped
                    bordered
                    dense
                    sort-icon-left
                    :small="true"
                    :no-local-sorting="true"
                    :fields="roFColumns"
                    :items="allRofRows"
                    :head-variant="'dark'"
                >
                </b-table>
            </div>
        </b-form-row>
    </div>
</template>
<script>
import * as Actions from "@/store/modules/ads/action-types"
import * as Mutations from "@/store/modules/ads/mutation-types"
import Spinner from "@/components/Shared/Spinner/Spinner"
import * as Helpers from "@/helpers/index.js"
import dayjs from "dayjs"

export default {
    name: "AdReach",
    props: {
        loadRofTab: Boolean,
        exceededRecommendedPeriodLimit: Boolean,
    },
    async mounted() {
        await this.loadGlobalConfigFromFile()
    },
    components: {
        Spinner,
    },
    computed: {
        measureTypeValue: {
            get() {
                return this.$store.getters.getAdsRoFQuery.measureType
            },
            set(newValue) {
                this.$store.commit(Mutations.setAdsRoFQuery, {
                    ...this.$store.getters.getAdsRoFQuery,
                    measureType: newValue,
                })
            },
        },
        aggregationTypeValue: {
            get() {
                return this.$store.getters.getAdsRoFQuery.aggregationType
            },
            set(newValue) {
                this.$store.commit(Mutations.setAdsRoFQuery, {
                    ...this.$store.getters.getAdsRoFQuery,
                    aggregationType: newValue,
                })
            },
        },
        maxFreqValue: {
            get() {
                return this.$store.getters.getAdsRoFQuery.maxFreq
            },
            set(newValue) {
                this.$store.commit(Mutations.setAdsRoFQuery, {
                    ...this.$store.getters.getAdsRoFQuery,
                    maxFreq: newValue,
                })
            },
        },
        targetGroup: {
            get() {
                return this.$store.getters.getAdsRoFQuery.targetGroup
            },
            set(newValue) {
                this.$store.commit(Mutations.setAdsRoFQuery, {
                    ...this.$store.getters.getAdsRoFQuery,
                    targetGroup: newValue,
                })
            },
        },
        firstChannelNames() {
            return Helpers.takeElementsUpTo200Chars(
                [
                    ...new Set(
                        this.$store.getters.getAdsResults.data.levelOneAdsWithLevelTwoAds
                            .filter(p => p.chosen)
                            .map(p => p.levelTwoAds)
                            .flat()
                            .map(p => p.providerName)
                    ),
                ].sort()
            )
        },
        channelNames() {
            return [
                ...new Set(
                    this.$store.getters.getAdsResults.data.levelOneAdsWithLevelTwoAds
                        .filter(p => p.chosen)
                        .map(p => p.levelTwoAds)
                        .flat()
                        .map(p => p.providerName)
                ),
            ].sort()
        },
        firstFilmcodes() {
                const uniqueFilmCodes = [...new Set(
                    this.$store.getters.getAdsResults.data.levelOneAdsWithLevelTwoAds
                        .filter(p => p.chosen)
                        .map(p => p.filmcode)
                )];
                // Order the unique film codes
                uniqueFilmCodes.sort();
                // Take elements up to 200 characters
                return Helpers.takeElementsUpTo200Chars(uniqueFilmCodes);
        },
        filmcodes() {
            const uniqueFilmCodes = [...new Set(
                    this.$store.getters.getAdsResults.data.levelOneAdsWithLevelTwoAds
                        .filter(p => p.chosen)
                        .map(p => p.filmcode)
                )];
                // Order the unique film codes
                uniqueFilmCodes.sort();
                // Take elements up to 200 characters
                return uniqueFilmCodes;
        },
        RoFStatus() {
            // both must be loaded since we need data from both
            const RoFStatus = this.$store.getters.getAdsRoFResults.status
            const analysisStatus = this.$store.getters.getAdsResults.status
            if (analysisStatus != "LOADED") {
                return RoFStatus == "LOADED" ? analysisStatus : RoFStatus
            } else {
                return RoFStatus
            }
        },
        initialTableColumns() {
            return this.$store.getters.getAdsRoFResults.tableData.initialTableColumns
        },
        initialTableItem() {
            return this.$store.getters.getAdsRoFResults.tableData.initialTableItem
        },
        roFColumns() {
            return this.$store.getters.getAdsRoFResults.tableData.roFColumns
        },
        allRofRows() {
            return this.$store.getters.getAdsRoFResults.tableData.allRofRows
        },
    },
    data() {
        return {
            showTableDetails: false,
            measureTypeOptions: [
                {
                    text: "Absolute",
                    value: "absolute",
                },
                {
                    text: "Relative",
                    value: "relative",
                },
            ],
            aggregationTypeOptions: [
                {
                    text: "Actual",
                    value: "actual",
                },
                {
                    text: "Cumulative",
                    value: "cumulative",
                },
            ],
            maxFreqOptions: [
                ...Array.from(new Array(20).keys()).map(idx => ({
                    text: `${idx + 1}`,
                    value: idx + 1,
                })),
            ],
            targetGroupRofOptions: [],
            channelsExpanded: false,
            filmcodesExpanded: false,
            isShowDetailsBtnVisible: true,
        }
    },
    watch: {
        async loadRofTab(loadRofTab) {
            if (loadRofTab) {
                await this.setupRofTab()
                this.updateRoF()
                this.$emit("setLoadRofTabBool", false)
                if (this.exceededRecommendedPeriodLimit) {
                    let query = this.$store.getters.getAdsQuery
                    let levelOneAdsWithLevelTwoAds = this.$store.getters.getAdsResults.data.levelOneAdsWithLevelTwoAds
                    let adsFiltered = levelOneAdsWithLevelTwoAds.filter(ad => {
                        const itemDate = new Date(ad.date)
                        return itemDate >= new Date(query.startDate) && itemDate <= new Date(query.endDate)
                    })
                    const updatedResults = {
                        ...this.$store.getters.getAdsResults,
                        data: {
                            ...this.$store.getters.getAdsResults.data,
                            levelOneAdsWithLevelTwoAds: adsFiltered,
                        },
                    }
                    this.$store.commit(Mutations.setAdsResults, updatedResults)
                }
            }
        },
    },
    methods: {
        showDetails() {
            this.isShowDetailsBtnVisible = false
            this.showTableDetails = true
        },
        expandOrCollapseChannels() {
            this.channelsExpanded = !this.channelsExpanded
            if (this.channelsExpanded) {
                this.initialTableItem[0].channelNames = [...this.channelNames].join(", ")
            } else {
                this.initialTableItem[0].channelNames = [...this.firstChannelNames].join(", ")
            }
        },
        expandOrCollapseFilmcodes() {
            this.filmcodesExpanded = !this.filmcodesExpanded
            if (this.filmcodesExpanded) {
                this.initialTableItem[0].filmcodes = [...this.filmcodes].join(", ")
            } else {
                this.initialTableItem[0].filmcodes = [...this.firstFilmcodes].join(", ")
            }
        },
        async setupRofTab() {
            this.filmcodesExpanded = false
            this.channelsExpanded = false
            let storedTargets = this.$store.getters.getAdsQuery.target_group
            var genderFunc = group => group == "all" ? "A" : group == "female" ? "W" : "M";
            this.targetGroupRofOptions = [...new Set(storedTargets.map(m => `${genderFunc(m.group)}${m.age_from}-${m.age_to}` ))]
            this.$store.commit(Mutations.setAdsRoFQuery, {
                ...this.$store.getters.getAdsRoFQuery,
                targetGroup: this.targetGroupRofOptions[0],
            })
        },
        async updateRoF() {
            let newDate
            if (this.exceededRecommendedPeriodLimit)
                newDate = dayjs(this.$store.getters.getAdsQueryForAPI.startDate)
                    .add(this.config_NumberOfConsumptionDaysRecommendedAd - 1, "d")
                    .format("YYYY-MM-DD")
            else newDate = this.$store.getters.getAdsQueryForAPI.endDate
            this.$store.commit(Mutations.setAdsRoFQuery, {
                ...this.$store.getters.getAdsRoFQuery,
                endDate: newDate,
            })
            this.$store.commit(Mutations.setAdsRoFResultsTableData, { ...this.$store.getters.getAdsRoFResults.tableData, allRofRows: [], roFColumns: [] })
            this.isShowDetailsBtnVisible = false
            await this.$store.dispatch(Actions.executeAdsRoFQuery)
            this.setInitialTableColumns()
            this.setInitialTableItem()
            this.setRoFColumns()
            this.setAllRofRows()
            this.isShowDetailsBtnVisible = true
            this.showTableDetails = false
        },
        setInitialTableColumns() {
            let roFQuery = this.$store.getters.getAdsRoFQuery
            const maxNbrFreq = Math.min(roFQuery.maxFreq, this.$store.getters.getAdsRoFResults.data.frequencyMatrix.length)
            let freq_array = []
            for (let idx = 0; idx < maxNbrFreq; idx++) {
                if (this.$store.getters.getAdsRoFResults.data.isCumulative)
                    freq_array.push({
                        key: `F${idx + 1}`,
                        label: `F${idx + 1}+`,
                        thClass: "text-right fwidth",
                        tdClass: "text-right",
                    })
                else
                    freq_array.push({
                        key: `F${idx + 1}`,
                        label: `F${idx + 1}`,
                        thClass: "text-right fwidth",
                        tdClass: "text-right",
                    })
            }
            let initialTableColumns = [
                {
                    key: "channelNames",
                    label: "Channel names",
                    tdClass: "smallfontsize",
                    thClass: "channelnamerofth",
                },
                {
                    key: "filmcodes",
                    label: "Film codes",
                    tdClass: "smallfontsize",
                    thClass: "filmcoderofth",
                },
                {
                    key: `targetGroup`,
                    label: `Target group`,
                    tdClass: "text-right w100",
                    thClass: "text-left targetgroupheaderwidth",
                },
                {
                    key: `universalNumber`,
                    label: `Universe`,
                    thClass: "text-left universeheaderwidth",
                    tdClass: "text-right w100",
                },
                {
                    key: `reach_1_plus_acc`,
                    label: roFQuery.measureType === "absolute" ? "Net Reach 1+ 000s" : "Net Reach 1+ %",
                    thClass: "text-right rofreachheaderwidth",
                    tdClass: "text-right",
                },
                // and average frequency
                {
                    key: `average_frquency`,
                    label: `Avg Freq`,
                    thClass: "text-right rofavgfreqheaderwidth",
                    tdClass: "text-right",
                },
                // and rating
                {
                    key: `rating`,
                    label: roFQuery.measureType === "absolute" ? "Rating 000s" : "Rating %",
                    thClass: "text-right rofratingheaderwidth",
                    tdClass: "text-right",
                },
                // and then the frequencies
                ...freq_array,
            ]
            this.$store.commit(Mutations.setAdsRoFResultsTableData, { ...this.$store.getters.getAdsRoFResults.tableData, initialTableColumns: initialTableColumns })
        },
        setInitialTableItem() {
            let rofData = this.$store.getters.getAdsRoFResults.data
            const reach_1_plus_acc = rofData.reach1PlusAcc.map(x => ({ reach_1_plus_acc: x }))
            const average_frquency = rofData.averageFrequency.map(x => ({ average_frquency: x }))
            const rating = rofData.rating.map(x => ({ rating: x }))
            let highestFreq = Math.max(...this.maxFreqOptions.map(o => o.value))
            let initialTableItem = [rofData.frequencyMatrix.slice(-1)[0]].map(row => {
                let slotIdx = rofData.frequencyMatrix.length - 1
                const freqRow = row.slice(0, highestFreq).reduce(
                    (prev, cur, freqIdx) => ({
                        ...prev,

                        // show no value on row/frequency that cannot have any value
                        [`F${freqIdx + 1}`]: freqIdx > slotIdx ? null : cur,
                    }),
                    {}
                )
                let universalNumber = rofData.universalNumber

                return {
                    channelNames: [...this.firstChannelNames].join(", "),
                    filmcodes: [...this.firstFilmcodes].join(", "),
                    targetGroup: this.targetGroup,
                    universalNumber: universalNumber,
                    ...freqRow,
                    ...reach_1_plus_acc[slotIdx],
                    ...average_frquency[slotIdx],
                    ...rating[slotIdx],
                }
            })
            this.$store.commit(Mutations.setAdsRoFResultsTableData, { ...this.$store.getters.getAdsRoFResults.tableData, initialTableItem: initialTableItem })
        },
        setRoFColumns() {
            let roFQuery = this.$store.getters.getAdsRoFQuery
            const maxNbrFreq = Math.min(roFQuery.maxFreq, this.$store.getters.getAdsRoFResults.data.frequencyMatrix.length)

            let freq_array = []
            for (let idx = 0; idx < maxNbrFreq; idx++) {
                if (this.$store.getters.getAdsRoFResults.data.isCumulative)
                    freq_array.push({
                        key: `F${idx + 1}`,
                        label: `F${idx + 1}+`,
                        thClass: "text-right fwidth",
                        tdClass: "text-right",
                    })
                else
                    freq_array.push({
                        key: `F${idx + 1}`,
                        label: `F${idx + 1}`,
                        thClass: "text-right fwidth",
                        tdClass: "text-right",
                    })
            }
            let roFColumns = [
                {
                    key: `date`,
                    label: "Consumption day",
                },
                {
                    key: `reach_1_plus_acc`,
                    label: roFQuery.measureType === "absolute" ? "Net Reach 1+ 000s" : "Net Reach 1+ %",
                    thClass: "text-right rofreachheaderwidth",
                    tdClass: "text-right",
                },
                // and average frequency
                {
                    key: `average_frquency`,
                    label: `Avg Freq`,
                    thClass: "text-right rofavgfreqheaderwidth",
                    tdClass: "text-right",
                },
                // and rating
                {
                    key: `rating`,
                    label: roFQuery.measureType === "absolute" ? "Rating 000s" : "Rating %",
                    thClass: "text-right rofratingheaderwidth",
                    tdClass: "text-right",
                },
                // and then the frequencies
                ...freq_array,
            ]
            this.$store.commit(Mutations.setAdsRoFResultsTableData, { ...this.$store.getters.getAdsRoFResults.tableData, roFColumns: roFColumns })
        },
        setAllRofRows() {
            const reach_1_plus_acc = this.$store.getters.getAdsRoFResults.data.reach1PlusAcc.map(x => ({ reach_1_plus_acc: x }))
            const average_frquency = this.$store.getters.getAdsRoFResults.data.averageFrequency.map(x => ({ average_frquency: x }))
            const rating = this.$store.getters.getAdsRoFResults.data.rating.map(x => ({ rating: x }))
            const dates = this.$store.getters.getAdsRoFResults.data.dates
            let highestFreq = Math.max(...this.maxFreqOptions.map(o => o.value))
            let allRofRows = this.$store.getters.getAdsRoFResults.data.frequencyMatrix.map((row, id) => {
                const freqRow = row.slice(0, highestFreq).reduce(
                    (prev, cur, freqIdx) => ({
                        ...prev,

                        // show no value on row/frequency that cannot have any value
                        [`F${freqIdx + 1}`]: freqIdx > id ? null : cur,
                    }),
                    {}
                )
                return {
                    date: dates[id],
                    ...freqRow,
                    ...reach_1_plus_acc[id],
                    ...average_frquency[id],
                    ...rating[id],
                }
            })
            this.$store.commit(Mutations.setAdsRoFResultsTableData, { ...this.$store.getters.getAdsRoFResults.tableData, allRofRows: allRofRows })
        }
    },
}
</script>
<style scoped>
::v-deep .tablemainresultclass th {
    font-size: 0.8rem;
    background-color: #337ab7 !important;
    border-color: #bfd5e8 !important;
    border-top: white;
    border-width: 2px 1px 2px 1px !important;
    vertical-align: middle;
    padding-top: 0;
    padding-bottom: 0;
}
.mx-datepicker {
    width: 100%;
}
select {
    height: 2rem;
    box-sizing: border-box;
    border: 1px solid #ced4da;
    font-size: 0.875rem;
}
.tdchanneltextwrapperclass {
    padding-bottom: 1.5rem;
}
.tdicon {
    width: 1rem;
    height: 1rem;
    position: absolute;
    right: 0.5rem;
    bottom: 0.2rem;
}
>>> .table tbody tr td {
    vertical-align: top;
}
.tdicon {
    cursor: pointer; /* Set cursor to hand */
}
>>> .targetgroupheaderwidth,
>>> .universeheaderwidth {
    width: 6rem;
}
>>> .thtablesrofsameheight {
    font-size: 0.8rem;
    line-height: 2.5;
}
</style>
